import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'

import queryClient from 'config/tanstackQuery'

import { Input } from 'components/form/input'
import useTemNewStore from 'store/client/temNewStore'
export default function BeltSizes({ idx,tab }) {
  const { orderNo } = useParams()
  const { values, setFieldValue } = useFormikContext()

  const cacheData = queryClient.getQueryData(['/list', 'sizeGroup'])
  const { anotherValue } = useTemNewStore();
  useEffect(() => {

    const updateBeltLabelSizes = () => {
      if (cacheData) {
        const findSizeData = cacheData.find((item) => item.id === values.sizeGroup);
        
        if (!findSizeData) {
          console.warn('Size data bulunamadı');
          return;
        }

        const isCocuk = findSizeData.name?.includes('ÇOCUK') || false;
        const isBebek = findSizeData.name?.includes('BEBEK') || false;
  
        const newSizes = findSizeData.sizes?.map((item) => ({
          name: isCocuk || isBebek ? item.size?.split(' ')[0] : String(item.europe),
          amount: '',
          amountWithDefect: '',
          cn: item.cn,
          cm: item.cm,
          sCode: item.sCode || String(item.europe),
        })) || [];

        setFieldValue(`beltLabel[${idx}].sizes`, newSizes);
      }
    };
  
    const updateBeltLabelSizes2 = () => {
      if (cacheData) {
        const findSizeData = cacheData.find((item) => item.id === values.sizeGroup);
        
        if (!findSizeData) {
          console.warn('Size data bulunamadı');
          return;
        }

        const isCocuk = findSizeData.name?.includes('ÇOCUK') || false;
        const isBebek = findSizeData.name?.includes('BEBEK') || false;
        
        const newSizes = findSizeData.sizes?.map((item, idx2) => ({
          name: isCocuk || isBebek ? item.size?.split(' ')[0] : String(item.europe),
          amount: values.beltLabel[idx]?.sizes[idx2]?.amount || '',
          amountWithDefect: values.beltLabel[idx]?.sizes[idx2]?.amountWithDefect || '',
          cn: item.cn,
          cm: item.cm,
          sCode: item.sCode || String(item.europe),
        })) || [];

        setFieldValue(`beltLabel[${idx}].sizes`, newSizes);
      }
    };
  

    if (!orderNo || (orderNo && values.beltLabel[idx]?.sizes?.length === 0)) {
      updateBeltLabelSizes();
    } else {
      updateBeltLabelSizes2();
    }
  }, [cacheData, orderNo, anotherValue]);

  const totalAmount = values.beltLabel[idx].sizes?.reduce((acc, curr) => {
    if (curr.amount) return acc + parseInt(curr.amount)
    return acc
  }, 0)

  const totalAmountWithDefect = values.beltLabel[idx].sizes?.reduce((acc, curr) => {
    const amount = curr.amountWithDefect
    if (amount.length > 1) return acc + parseInt(amount)
    return acc
  }, 0)

  return (
    <div className="rounded border border-dashed p-2">
      <div className="mb-2 grid grid-cols-4 gap-x-5 text-sm font-medium text-simsek">
        <p>Beden</p>
        <p>Adet</p>
        <p>%</p>
        <p>Fireli Adet</p>
      </div>
      <div className="space-y-1">
        {values.beltLabel[idx].sizes.length < 1 ? (
          <div className="bg-rose-400 rounded p-2 text-center my-4">
            <p className="text-white text-sm">Lütfen beden tablosu seçiniz!</p>
          </div>
        ) : (
          values.beltLabel[idx].sizes.map((_, index) => {
            const amount = values.beltLabel[idx].sizes[index]?.amount
            const percent =
              (values.beltLabel[idx].sizes[index]?.amount *
                values.beltLabel[idx].sizeDefectivePercent) /
                100 || 0
            const wastageQuantity = String(parseInt(amount) + parseInt(percent))
            return (
              <div className="grid grid-cols-4 gap-x-5" key={index}>
                <Input
                  name={`beltLabel[${idx}].sizes[${index}].name`}
                  disabled
                  autoComplete="off"
                />
                <Input
                  name={`beltLabel[${idx}].sizes[${index}].amount`}
                  onWheel={(e) => e.target.blur()}
                  autoComplete="off"
                />

                <Input name={`beltLabel[${idx}].sizeDefectivePercent`} autoComplete="off"
                  type="number"
                  min={0}
                  max={20}
                  step={1}
                  inputMode="numeric"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const digitsOnly = String(e.target.value).replace(/\D/g, '')
                    if (digitsOnly === '') {
                      setFieldValue(`beltLabel[${idx}].sizeDefectivePercent`, '')
                      return
                    }
                    let n = parseInt(digitsOnly, 10)
                    if (Number.isNaN(n)) return
                    n = Math.min(20, Math.max(0, n))
                    setFieldValue(`beltLabel[${idx}].sizeDefectivePercent`, n)
                  }}
                />



                <Input
                  name={`beltLabel[${idx}].sizes[${index}].amountWithDefect`}
                  autoComplete="off"
                  value={
                    values.beltLabel[idx].sizes[index].amount.length === 0
                      ? ' '
                      : wastageQuantity
                  }
                  disabled
                />
              </div>
            )
          })
        )}
        {values.beltLabel[idx].sizes.length > 0 && (
          <div className="grid grid-cols-4 gap-x-10">
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmount}</p>
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmountWithDefect}</p>
          </div>
        )}
      </div>
    </div>
  )
}
